'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SiteTitle;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'site-title';

function SiteTitle(_ref) {
  var title = _ref.title,
      headerTagline = _ref.headerTagline,
      headerTagline2 = _ref.headerTagline2,
      headerHeadline = _ref.headerHeadline;

  var logoBankingCareer = require('shared/images/icons/image-banking.png');
  var logoBankingCareerLrg = require('shared/images/icons/image-banking-lrg.png');
  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME },
    _react2.default.createElement(
      'div',
      { className: 'site-info' },
      _react2.default.createElement('img', { src: logoBankingCareer, className: 'site-log-small', alt: 'Banking on My Career' }),
      _react2.default.createElement('img', { src: logoBankingCareerLrg, className: 'site-logo-large', alt: 'Banking on My Career. Jobs in Banking, Isurance and Wealth Management' })
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/SiteTitle/SiteTitle.jsx
// module id = 1131
// module chunks = 0